export const errorCodes = {
  duplicateEmail: 'DUPLICATED_EMAIL',
  duplicateEmailCust: 'USER_ALREADY_REGISTERED',
  duplicateIdCust: 'CUSTOMER_ALREADY_PRESENT_WITH_CUSTOMER_ID',
  duplicateUser: 'USER_ALREADY_REGISTERED',
  rfIdExists: 'ERR_RFID_ID_EXISTS',
  rfIdSerialNotExists: 'ERR_RFID_SERIAL_NOT_EXISTS',
  dublicatedEndCustomerId: 'DUPLICATED_END_CUSTOMER_ID',
};
